import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './store'
import axios from 'axios'
import {getToken} from './utils/Common.js'

axios.interceptors.request.use(

  request => {
    if (getToken()){
      request.headers['Authorization'] = "token " + getToken()
    }
    
    console.log(getToken())
    return request
  },
  error => {
    return Promise.reject(error)
  }

)

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
